export default __webpack_public_path__ + "static/media/BA-ENG-RGB.61d305ec.png";